import { render, staticRenderFns } from "./ubicaciones.vue?vue&type=template&id=155b1c2a&scoped=true"
import script from "./ubicaciones.vue?vue&type=script&lang=js"
export * from "./ubicaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155b1c2a",
  null
  
)

export default component.exports